"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.PopperWrapper = exports.Overlay = exports.MobileWrapper = exports.HeaderWrapper = exports.ContentWrapper = exports.ActionButtons = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = require("@emotion/react");
var _react2 = require("motion/react");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const arrowDefaultStyle = process.env.NODE_ENV === "production" ? {
  name: "2bhmfv",
  styles: "content:'';position:absolute;border:10px solid"
} : {
  name: "1kxo8yf-arrowDefaultStyle",
  styles: "content:'';position:absolute;border:10px solid;label:arrowDefaultStyle;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
const arrowTop = /*#__PURE__*/(0, _react.css)("&::after{", arrowDefaultStyle, " bottom:100%;left:50%;margin-left:-10px;border-color:transparent transparent #ffffff transparent;}" + (process.env.NODE_ENV === "production" ? "" : ";label:arrowTop;"));
const arrowLeft = /*#__PURE__*/(0, _react.css)("&::after{", arrowDefaultStyle, " top:50%;right:100%;margin-top:-10px;border-color:transparent #ffffff transparent transparent;}" + (process.env.NODE_ENV === "production" ? "" : ";label:arrowLeft;"));
const arrowRight = /*#__PURE__*/(0, _react.css)("&::after{", arrowDefaultStyle, " top:50%;left:100%;margin-top:-10px;border-color:transparent transparent transparent #ffffff;}" + (process.env.NODE_ENV === "production" ? "" : ";label:arrowRight;"));
const arrowBottom = /*#__PURE__*/(0, _react.css)("&::after{", arrowDefaultStyle, " top:100%;left:50%;margin-left:-10px;border-color:#ffffff transparent transparent transparent;}" + (process.env.NODE_ENV === "production" ? "" : ";label:arrowBottom;"));
var _ref = process.env.NODE_ENV === "production" ? {
  name: "50f49a",
  styles: "button{padding:0.25em;}"
} : {
  name: "j80vp1-default",
  styles: "button{padding:0.25em;};label:default;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
const styles = exports.styles = {
  default: isCustomButton => /*#__PURE__*/(0, _react.css)("position:relative;.open-button-wrapper{position:relative;border:2px solid transparent;border-radius:4px;transition:all 200ms;width:fit-content;", !isCustomButton && _ref, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:default;")),
  active: theme => /*#__PURE__*/(0, _react.css)(".open-button-wrapper{border-color:", theme.primary, ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:active;"))
};
const PopperWrapper = exports.PopperWrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e1a8jgkt5"
} : {
  target: "e1a8jgkt5",
  label: "PopperWrapper"
})(({
  placement
}) => /*#__PURE__*/(0, _react.css)("position:absolute;left:50%;transform:translateX(-50%);height:min-content;width:min-content;border-radius:4px;background:#ffffff;padding:1em 1.5em;box-shadow:0 2px 4px 0 rgba(0, 0, 0, 0.1);z-index:3;display:flex;flex-direction:column;", placement === 'bottom' && arrowTop, " ", placement === 'top' && arrowBottom, " ", placement === 'left' && arrowRight, " ", placement === 'right' && arrowLeft, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:PopperWrapper;")));
const HeaderWrapper = exports.HeaderWrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e1a8jgkt4"
} : {
  target: "e1a8jgkt4",
  label: "HeaderWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "1lrodrg",
  styles: "display:flex;width:100%;justify-content:space-between;padding:0.5em 0"
} : {
  name: "1lrodrg",
  styles: "display:flex;width:100%;justify-content:space-between;padding:0.5em 0",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const ContentWrapper = exports.ContentWrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e1a8jgkt3"
} : {
  target: "e1a8jgkt3",
  label: "ContentWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "1qsi57v",
  styles: "padding:1em 0;min-width:125px"
} : {
  name: "1qsi57v",
  styles: "padding:1em 0;min-width:125px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const ActionButtons = exports.ActionButtons = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e1a8jgkt2"
} : {
  target: "e1a8jgkt2",
  label: "ActionButtons"
})(process.env.NODE_ENV === "production" ? {
  name: "1raqx5r",
  styles: "width:100%;display:flex;justify-content:flex-end;align-items:center;padding-top:0.5em;gap:1em;button:last-of-type{min-width:100px;}"
} : {
  name: "1raqx5r",
  styles: "width:100%;display:flex;justify-content:flex-end;align-items:center;padding-top:0.5em;gap:1em;button:last-of-type{min-width:100px;}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const Overlay = exports.Overlay = /*#__PURE__*/(0, _base.default)(_react2.motion.div, process.env.NODE_ENV === "production" ? {
  target: "e1a8jgkt1"
} : {
  target: "e1a8jgkt1",
  label: "Overlay"
})(process.env.NODE_ENV === "production" ? {
  name: "x8x934",
  styles: "position:fixed;top:0;left:0;right:0;bottom:0;z-index:1001;background:rgba(0, 0, 0, 0.27);overflow:auto"
} : {
  name: "x8x934",
  styles: "position:fixed;top:0;left:0;right:0;bottom:0;z-index:1001;background:rgba(0, 0, 0, 0.27);overflow:auto",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const MobileWrapper = exports.MobileWrapper = /*#__PURE__*/(0, _base.default)(_react2.motion.div, process.env.NODE_ENV === "production" ? {
  target: "e1a8jgkt0"
} : {
  target: "e1a8jgkt0",
  label: "MobileWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "1xpklsy",
  styles: "position:absolute;left:0;right:0;bottom:0;min-height:60vh;z-index:1002;background-color:white;border-radius:10px 10px 0 0;padding:1em"
} : {
  name: "1xpklsy",
  styles: "position:absolute;left:0;right:0;bottom:0;min-height:60vh;z-index:1002;background-color:white;border-radius:10px 10px 0 0;padding:1em",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});